 <template>
    <div class="atlas">  
        <h2>知识图谱构建</h2>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="抽取方式："  prop="method">
                杏林大模型
                <!-- <el-radio-group v-model="ruleForm.method">
                    <el-radio label="llm">大模型</el-radio>
                    <el-radio label="rule">神经网络模型</el-radio>
                </el-radio-group> -->
            </el-form-item>
            <el-form-item label="抽取内容："  prop="text">
                <el-input type='textarea' v-model="ruleForm.text" :rows="6"  :cols="4"  class="problem"  placeholder="请输入待构建知识图谱的原始文本内容，并选择您希望的构建方式，最后点击“开始抽取”按钮以启动知识抽取流程。"  ></el-input>
            </el-form-item>
            <el-form-item label=""  >
                <el-button  type="primary"   @click="begin_click" :loading='isBegin'>开始抽取</el-button>
            </el-form-item>
        </el-form>  
        <div class="atlas-cont" v-if='isShowGrap' v-loading='isBegin'> 
            <d3-knowledge-graph
                ref="atlasGraph"
                class="atlas-graph-container"
                :graph-data="newData"
                :side-label="sideLabel"
            />

            <div class="cont-btn">   
                <el-button  type="primary" plain  @click="save_pic">保存图片</el-button>
                 <el-button  type="success"   @click="derive">导出</el-button>
            </div>
            <div class="atlas-list">
                <el-table
                    :data='tableList'
                    @sort-change="sort_change"
                    :header-cell-style="{background:'#396de7',color:'#fff'}"
                    size='mini'
                    row-key="id"
                    border
                    default-expand-all>
                    <el-table-column
                        sortable
                        label="NO"
                        align="center"
                        prop="num"
                        width='140'
                    >
                        <template slot-scope="scope">
                            <span >{{scope.$index+1}}</span>  
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="startNode"
                        sortable
                        label="节点名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="endNode"
                        sortable
                        label="节点名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="relation" 
                        label="关系">
                    </el-table-column>
                </el-table> 
                <el-pagination 
                    size='small'
                    class="page-wrap"  
                    @current-change="changePage" 
                    @size-change="sizeChange"
                    background
                    :current-page="pageInfo.pageNum" 
                    :page-count="pageInfo.pageTotal" 
                    :page-size="pageInfo.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :total="pageInfo.total"
                    layout="total, sizes, prev, pager, next, jumper" >
                </el-pagination>
            </div>
        </div>  
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
import D3KnowledgeGraph from '../../components/D3KnowledgeGraph.vue'
import { knowledgeGraph,knowledgeGraphPage,saveFrontLog } from '../../io/api.js'

export default {
    components: {
        D3KnowledgeGraph,
    },
    data () {
        return { 
            ruleForm:{
                method:"llm",
                text:'',//张某某,女,14岁,学生,1983年5月6日初诊。患者1年前月经初潮,近3个月每逢经前1～2天出现鼻衄,血量较多,同时出现乳房胀痛,心烦急燥易怒,头痛,纳呆,腰腹疼痛,二便正常。望之患者体瘦,面色无华,舌苔薄黄,脉弦数。姚老认为此属肾阴不足,水不涵木,虚火上炎,迫血妄行所致之逆经,治以滋阴清热、柔肝止血之法。处方:细生地12g,杭白芍9g,粉丹皮9g,干百合9g,白茅根12g,杭菊花9g,青竹茹12g,大小蓟各24g,川牛膝9g。水煎服。患者服药4剂后鼻衄愈。访3个月无复
            },
            rules: {
                method:[
                    { required: true, message: '请选择抽取方式', trigger: 'change' }
                ],
                text: [
                    { required: true, message: '请输入您要抽取的内容', trigger: 'blur' }, 
                ],
            },  
            textId:'',
            labelPosition:'center', //center:居中,top:上方,left:左边,right:右边 
            sideLabel:'hidden',     
            newData: { nodes: [], edges: [] },
            isBegin:false,
            isShowGrap:false,
            graphList:{},   
            tableList:[],
            isNodata:false, 
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }, 

        }
    },
    watch: { 
        
    },
    mounted () { 
    },
    methods: { 
        initData(){  
            this.tableList=[];  
            this.isNodata=false;
            this.pageInfo= {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }; 
        },
        begin_click(){
            this.initData();
            this.isBegin=true;
            knowledgeGraph(this.ruleForm).then(res=>{
                let data =res.data;
                if(data.status=="success"){
                    this.isShowGrap=true;
                    this.graphList=data.data||[];
                    this.textId=data.textId||'';
                    if(this.textId){
                        this.getTable()
                    }
                    this.$nextTick(()=>{
                        this.data_process();
                    })
                    console.log(this.graphList)
                } else{
                    this.$message.error( data.message||'抽取请求失败～')
                }
                this.isBegin=false;
            }) 
        },
        getTable(){
            let params={
                limit:this.pageInfo.pageSize,
                page:this.pageInfo.pageNum,
                textId:this.textId
            }
            knowledgeGraphPage(params).then(res=>{
                let data=res.data;
                if(data.code==0){
                    this.tableList=data.data.list||[];
                    this.pageInfo.total=data.data.total||1;
                }else{
                    this.$message.error( data.msg||'抽取请求失败～')
                }
            })
        },
        //数据处理
        data_process(){ 
            let nodesData=this.graphList &&this.graphList.nodes||[];
            let edgesData=this.graphList &&this.graphList.edges||[]; 
            if(nodesData.length==0){
                this.isNodata = true
                return
            }
            this.newData={
                nodes:[],
                edges:[],
            }
            nodesData&&nodesData.forEach((item,index)=>{ 
                // item.label=item.name;
                this.$set(item,'num',index+1)
                this.newData.nodes.push(item)
            }) 
            edgesData&&edgesData.forEach((item,index)=>{

                // item.label=item.weight;
                this.$set(item,'num',index+1)
                this.newData.edges.push(item)
                
            })  
            this.changePage(1)

        },
        save_pic () {
            const el = this.$refs.atlasGraph && this.$refs.atlasGraph.$el
            if (!el) return
            window.oldRatio = window.devicePixelRatio
            window.devicePixelRatio = 4
            html2canvas(el, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff',
                logging: false,
            }).then((canvas) => {
                const a = document.createElement('a')
                a.download = '复杂网络分析结果图.png'
                a.href = canvas.toDataURL('image/png')
                a.click()
                window.devicePixelRatio = window.oldRatio
            }).catch(() => {
                window.devicePixelRatio = window.oldRatio
                this.$message.error('导出图片失败')
            })
            saveFrontLog({
                moduleName: "构建知识图谱",
                operationType: "保存图谱",
                logContent: `输入【${this.ruleForm.text}】，保存了知识图谱图片。`,
            }).then(res=>{
                // console.log(res)
            })
        },
        derive(){
            // saveFrontLog({
            //     moduleName: "构建知识图谱",
            //     operationType: "导出表格",
            //     logContent: `输入【${this.ruleForm.text}】，导出了三元组表格。`,
            // }).then(res=>{
            //     // console.log(res)
            // })
            let strUrl =  `https://www.tcmkb.cn/tcmkb-api/knowledge_graph_relation/export?textId=${this.textId}`;
            window.open(strUrl); 
            //下载乱码
            // exportExcelByIds({baseId:this.storeId,ids,responseType: 'blob'}).then(res=>{
            //     fileDownload(res.data, '医案.xls')
            // })
        },
        changePage(num) { 
            this.pageInfo.pageNum = num;  
            this.getTable()
        }, 
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column; 
            this.changePage(1);

        }, 
        sizeChange(val){ 
            this.pageInfo.pageSize=val; 
            this.changePage(1)
        }, 
    }
}
</script> 
<style lang="less" scoped> 
.atlas{
    width: 1200px;
    margin: 40px auto; 
    padding-bottom: 40px; 
    ::v-deep .el-textarea__inner {  
        resize: none;  
    } 
    .cont-btn{
        text-align: right;
        margin-bottom: 10px;
    }
}   
.atlas-graph-container {
    border: 1px dashed #396de7;
    width: 100%;
    height: 750px;
    margin-bottom: 20px;
} 
</style>